module.exports = {"apiKey":"AIzaSyBQEDHG8QVnvgKspAlXmAOWrE-FtA0_KVk","authDomain":"flowerai-staging.firebaseapp.com","databaseURL":"https://flowerai-staging.firebaseio.com","projectId":"flowerai-staging","storageBucket":"","messagingSenderId":"133102616831"}


//////////////////
// WEBPACK FOOTER
// ./src/secrets/firebase-config.json
// module id = 521
// module chunks = 0